import { http } from "./post"
import urls from "./urls"

const CommonSource = {
  viewedCookiePolicy: () => http(urls.viewedCookiePolicy, "GET"),
  updateViewedCookiePolicy: viewed_cookie_policy =>
    http(urls.updateViewedCookiePolicy, "POST", { viewed_cookie_policy }),
  trackUserRecommendationAction: (marketplaceItemToken, actionType) => http(urls.trackUserRecommendationAction, "POST",
      { marketplaceItemToken, actionType }
    )
}

export default CommonSource



// WEBPACK FOOTER //
// ./assets/common/Source.js